import "core-js/modules/es.array.find";
import "core-js/modules/es.array.join";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.split";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { questionnaireList, deleteQuestionnaire } from "@/api/gmtool/packageCode";
import parameterPopup from "./components/parameterPopup.vue";
import { gmTool, serchSelect } from "@/mixins/index";
import addQuestionItem from './components/addQuestionItem.vue';
import questionResult from "./components/questionResult.vue";
export default {
  name: "surveyQuestionnaireList",
  components: {
    addQuestionItem: addQuestionItem,
    parameterPopup: parameterPopup,
    questionResult: questionResult
  },
  mixins: [gmTool, serchSelect],
  data: function data() {
    return {
      total: 0,
      list: [],
      paramsData: {
        page: 1
      },
      languageList: {
        'cn': this.$t('langChinese'),
        'en': this.$t('langEnglish'),
        'all': this.$t('langAll')
      }
    };
  },
  created: function created() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.getserverList();

            case 2:
              _this.getList(1);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  beforeDestroy: function beforeDestroy() {},
  methods: {
    Renewal: function Renewal() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.getserverList();

              case 2:
                _this2.getList(1);

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    getList: function getList(e) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.paramsData.page = e;
                _this3.reqLoading = true;
                questionnaireList(_this3.paramsData).then(function (res) {
                  if (res.status == 200) {
                    _this3.tableData = res.data.data;
                    _this3.total = res.data.total;
                    console.log("serverLists", _this3.serverLists);
                    _this3.tableData = _this3.tableData.map(function (item) {
                      var serverNames = [];

                      if (item.server_range) {
                        var serverIds = item.server_range.split(',');
                        serverNames = serverIds.map(function (id) {
                          var server = _this3.serverLists.find(function (s) {
                            return s.serverID == id;
                          });

                          return server ? server.serverName : id;
                        });
                      }

                      return _objectSpread(_objectSpread({}, item), {}, {
                        server_names: serverNames.join(', ')
                      });
                    });
                  }
                }).finally(function () {
                  _this3.reqLoading = false;
                });

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    //删除
    handleDelete: function handleDelete(row) {
      var _this4 = this;

      this.$confirm(this.$t('confirmDeleteQuestionnaire'), this.$t('tip'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                deleteQuestionnaire({
                  ids: [row.id],
                  is_prod: row.is_prod
                }).then(function (res) {
                  if (res.status == 200) {
                    _this4.getList(1);

                    _this4.$message({
                      type: "success",
                      message: _this4.$t('deleteSuccess')
                    });
                  }
                });

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      })));
    }
  }
};